import React from 'react';
import BlockRenderer from '../BlockRenderer';

interface Child {
  label?: string;
  value?: string;
  [key: string]: any; // For other block properties when used with BlockRenderer
}

interface ChildrenLayoutBlockProps {
  block: {
    children?: Child[];
    direction?: 'row' | 'column';
  };
  cardContext?: any;
}

const ChildrenLayout: React.FC<ChildrenLayoutBlockProps> = ({
  block,
  cardContext,
}) => {
  if (!block || !block.children) {
    return null;
  }

  return (
    <div
      className="children-layout"
      style={{
        display: 'flex',
        flexDirection: block.direction || 'column',
      }}
    >
      {block.children.map((child, index) => (
        <div key={index} className="child-wrapper">
          {child.label && child.value ? (
            <div className="label-value-pair">
              <span className="label">{child.label}</span>
              <span className="value">{child.value}</span>
            </div>
          ) : (
            <BlockRenderer block={child} cardContext={cardContext} />
          )}
        </div>
      ))}
    </div>
  );
};

export default ChildrenLayout;
